<!-- ── Banner Carousel ──────────────────────────────────── -->
<app-banner-carousel-b></app-banner-carousel-b>

<!-- ── Events section ──────────────────────────────────── -->
<div class="bg-[var(--black)]">
  <div class="mx-auto max-w-screen-desktop container-padding">
    <h2 id="eventos" class="text-[var(--yellow)] uppercase text-[34px]/[34px] font-normal mobile-m:text-left text-center py-5 m-0">{{ 'home.upcomingEvents' | translate }}</h2>
  </div>
</div>

<app-events-showcase
  [events]="events"
  [isLoading]="isLoadingEvents"
  [showFilters]="false"
  [showTitle]="false"
  [compact]="true">
</app-events-showcase>

<!-- ── Custom hop banner ───────────────────────────────── -->
<div class="relative bg-cover bg-center lg:h-[600px] md:h-[600px] h-[550px]"
  style="background-image: url('assets/mapa-custom.webp'); background-color: var(--grey);">
  <div class="mx-auto max-w-screen-desktop container-padding h-full flex flex-col justify-center items-center gap-4">
    <img src="assets/jarra.webp" alt="DH - Drinkhopping" style="width: auto; height: 40px;">
    <h2 class="text-[55px]/[55px] font-[400] uppercase text-center">{{ 'home.customPlan' | translate }}</h2>
    <p class="text-[18px]/[27px] font-[400] max-w-[770px] text-center">{{ 'home.customPlanDesc' | translate }}</p>
    <app-button [function]="createCustomReservation.bind(this)" [text]="'home.startHere' | translate" [styleType]="'primary-flat'" [fullWidth]="true"></app-button>
  </div>
</div>

<!-- ── Establecimientos section ───────────────────────── -->
<section class="partners-section">

  <div class="partners-blob partners-blob--left" aria-hidden="true"></div>
  <div class="partners-blob partners-blob--right" aria-hidden="true"></div>

  <div class="relative z-10">

    <!-- Header -->
    <div class="partners-header mx-auto max-w-screen-desktop container-padding" style="margin-bottom: 32px;">
      <div class="flex justify-center items-center gap-4 w-full">
        <hr class="flex-grow" style="border-color: var(--dark-orange);">
        <span class="text-[20px]/[20px] uppercase text-center text-[var(--dark-orange)] whitespace-nowrap" style="font-family: 'Protest Strike', sans-serif;">{{ 'home.togetherExperience' | translate }}</span>
        <hr class="flex-grow" style="border-color: var(--dark-orange);">
      </div>
    </div>

    <!-- Skeleton -->
    <div *ngIf="isLoadingBreweries" class="partners-marquee-wrap">
      <div class="partners-marquee">
        <div *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]" class="marquee-skeleton"></div>
      </div>
    </div>

    <!-- Live marquee -->
    <div *ngIf="!isLoadingBreweries && breweries.length > 0"
      class="partners-marquee-wrap"
      #marqueeWrap
      (mouseenter)="marqueePaused = true"
      (mouseleave)="marqueePaused = false"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()">
      <div class="partners-marquee"
        [class.paused]="marqueePaused"
        [style.transform]="'translateX(' + marqueeOffset + 'px)'"
        [class.no-animation]="isDragging"
        #marqueeTrack>
        <ng-container *ngFor="let repeat of [1,2,3,4,5,6]">
          <a *ngFor="let b of breweries"
            [routerLink]="['/brewery', b.slug]"
            class="marquee-item"
            [attr.aria-label]="b.name"
            (click)="$event.preventDefault(); !isDragging && navigateTo(b.slug)">
            <img [src]="b.logoUrl" [alt]="'DrinkHopping - ' + b.name" class="marquee-logo" />
          </a>
        </ng-container>
      </div>
    </div>

    <!-- Empty -->
    <div *ngIf="!isLoadingBreweries && breweries.length === 0" class="py-12 text-center">
      <p class="text-[18px] font-medium text-[var(--dark-grey)]">{{ 'home.noBreweries' | translate }}</p>
    </div>

  </div>
</section>
